// extracted by mini-css-extract-plugin
module.exports = {"leave-tab-dialog":"LeaveTabDialog_leave-tab-dialog__8e1U6","button-group":"LeaveTabDialog_button-group__aWydL"};